/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Sunset',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path d="M14.512 19.313a.6.6 0 1 1 0 1.2H9.487a.6.6 0 1 1 0-1.2h5.025zm3.643-3.159a.6.6 0 1 1 0 1.2H5.845a.6.6 0 1 1 0-1.2h12.31z" />
          <path
            fillRule="evenodd"
            d="M12.001 8.334a4.81 4.81 0 0 1 4.807 4.663H21.4a.6.6 0 1 1 0 1.2H2.599a.6.6 0 0 1 0-1.2h4.595a4.81 4.81 0 0 1 4.807-4.663zm0 1.199c-1.945 0-3.531 1.538-3.608 3.464h7.215a3.61 3.61 0 0 0-3.606-3.464z"
          />
          <path d="M3.336 8.545a.6.6 0 0 1 .819-.221l1.519.877a.6.6 0 0 1-.601 1.039l-1.518-.877a.6.6 0 0 1-.22-.818zm16.508-.221a.6.6 0 0 1 .82.221.6.6 0 0 1-.22.818l-1.518.877a.6.6 0 0 1-.82-.22.6.6 0 0 1 .221-.819l1.518-.877zm-12.9-3.456a.6.6 0 0 1 .818.22l.877 1.519a.6.6 0 0 1-.219.819.6.6 0 0 1-.82-.22l-.877-1.518a.6.6 0 0 1 .221-.82zm9.292.22a.601.601 0 1 1 1.04.601l-.877 1.518a.6.6 0 0 1-.82.22.6.6 0 0 1-.219-.819l.876-1.519zm-4.142-1.6a.6.6 0 0 1 .6.6v1.753a.6.6 0 1 1-1.2 0V4.088a.6.6 0 0 1 .601-.6z" />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
